import React from 'react'

const HeroWithImage = () => {
  return (
    <section className='tw-relative tw-w-full tw-h-screen tw-overflow-hidden'>
      <img
        src='assets/images/cooperation/Zd1.jpeg'
        alt='Platforma dla branży architektoniczno-projektowej'
        className='tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover'
      />

      <div className='tw-absolute tw-inset-0 tw-bg-black/60' />

      <div className='tw-relative tw-z-10 tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-text-center tw-px-4 sm:tw-px-6 lg:tw-px-8'>
        <h1 className='tw-text-white tw-text-3xl sm:tw-text-4xl lg:tw-text-5xl xl:tw-text-6xl tw-font-bold tw-mb-6'>
          Dołącz do platformy stworzonej dla branży architektoniczno-projektowej
        </h1>
        <p className='tw-text-neutral-200 tw-text-lg sm:tw-text-xl lg:tw-text-2xl tw-max-w-3xl lg:tw-max-w-4xl tw-leading-relaxed'>
          Zbuduj widoczność swojej marki wśród architektów i projektantów na całym etapie<br />
          procesu projektowego.
        </p>
      </div>
    </section>
  )
}

export default HeroWithImage
